/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_All_LabelInputs */

const en_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace All`)
};

const fr_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout remplacer`)
};

const de_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ersetzen`)
};

const it_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci tutto`)
};

const ru_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заменить все`)
};

const es_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar todo`)
};

const zh_cn2_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部替换`)
};

const ja_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて置換`)
};

const hi_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी को बदलें`)
};

const pt_pt2_find_replace_replace_all_label = /** @type {(inputs: Find_Replace_Replace_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir tudo`)
};

/**
* | output |
* | --- |
* | "Replace All" |
*
* @param {Find_Replace_Replace_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_all_label = /** @type {((inputs?: Find_Replace_Replace_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_replace_all_label(inputs)
	if (locale === "de") return de_find_replace_replace_all_label(inputs)
	if (locale === "it") return it_find_replace_replace_all_label(inputs)
	if (locale === "ru") return ru_find_replace_replace_all_label(inputs)
	if (locale === "es") return es_find_replace_replace_all_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_replace_all_label(inputs)
	if (locale === "ja") return ja_find_replace_replace_all_label(inputs)
	if (locale === "hi") return hi_find_replace_replace_all_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_replace_all_label(inputs)
	return en_find_replace_replace_all_label(inputs)
});